 //--
import request from "../../../core/wrappers/axios-wrapper";
import { ApiURL } from "../../../types/constants/apiUrls/api-urls";
import { RequestType } from "../../../types/enums/request-enums";
 //#region comment metod

 const DeleteBillingInformation = (data: any): Promise<any>  =>
 request({ 
   url: ApiURL.Command.DeleteBillingInformation,
   method: RequestType.DELETE,
   data,
 });  
 const PostGetBillingInformation = (data: any): Promise<any>  =>
 request({ 
   url: ApiURL.Command.PostGetBillingInformation,
   method: RequestType.POST,
   data,
 });  
 const UpdateBillingInformation = (data: any): Promise<any>  =>
 request({ 
   url: ApiURL.Command.UpdateBillingInformation,
   method: RequestType.PUT,
   data
  });  
  const GetDocumentNo = (data: any): Promise<any>  =>
  request({ 
    url: ApiURL.Command.GetDocumentNo,
    method: RequestType.POST,
    data
   });  
   
  
 
const BillingCommand = {
  DeleteBillingInformation,
  PostGetBillingInformation,
  UpdateBillingInformation,
  GetDocumentNo   

}

export default BillingCommand;
